export class Unidade {
  constructor({ id, nome, logo }) {
    this.id = id;
    this.nome = nome;
    this.logo = logo;
  }
}
